import {
  combineReducers,
  type Reducer,
  type UnknownAction,
} from "@reduxjs/toolkit";
import type { ConflictEntry } from "@/features/sparxsEditor/store/slices/conflict/conflictSlice";
import type { SparxsEventHandlerState } from "@/features/sparxsEditor/store/slices/interaction/eventHandlerSlice";

export type SparxsEditorAuxiliaryState = {
  conflict: ConflictEntry[];
  formState: string;
  sparxsEventHandler: SparxsEventHandlerState;
};

const initialConflict: ConflictEntry[] = [];

const initialFormState = "";

const initialEventHandler: SparxsEventHandlerState = {
  updatePreview: false,
  blueprintReloadNonce: 0,
  sparxSaveEpoch: 0,
  lastSparxSaveToastFeedback: null,
};

const freeze =
  <S>(initial: S): Reducer<S> =>
  (state = initial, _action: UnknownAction) =>
    state;

export const sparxsEditorAuxiliaryPlaceholderReducer = combineReducers({
  conflict: freeze(initialConflict),
  formState: freeze(initialFormState),
  sparxsEventHandler: freeze(initialEventHandler),
});
